import { useWebFormState } from '@/modules/WebForm/data/formState';
import { Answer } from '@/modules/WebForm/interfaces';
import { createAnswer } from '@/modules/WebForm/utils';
import { Box, Textarea } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuestionItem } from './context';

import { IFormActions, IFormState } from '@/modules/WebForm/interfaces';

export const QuestionCommentPane: React.FC = () => {
  const { t } = useTranslation();
  const { question } = useQuestionItem();
  const answers = useWebFormState((state: IFormState & IFormActions) => state.answers);
  const onChangeAnswer = useWebFormState((state: IFormState & IFormActions) => state.onChangeAnswer);

  const answer = answers[question.id] as Answer | Answer[] | undefined;
  const currentAnswerComment = Array.isArray(answer)
    ? answer[0]?.comment
    : answer?.comment;

  const [comment, setComment] = React.useState(currentAnswerComment || '');

  React.useEffect(() => {
    setComment(currentAnswerComment || '');
  }, [currentAnswerComment]);

  const handleBlur = () => {
    if (comment === currentAnswerComment) return;

    if (answer) {
      if (Array.isArray(answer)) {
        if (answer.length === 0) {
          onChangeAnswer(question.id, [createAnswer(null, undefined, undefined, comment)]);
        } else {
          onChangeAnswer(
            question.id,
            answer.map((a) => ({ ...a, comment })),
          );
        }
      } else {
        onChangeAnswer(question.id, { ...answer, comment });
      }
    } else {
      onChangeAnswer(question.id, createAnswer(null, undefined, undefined, comment));
    }
  };

  return (
    <Box w="full">
      <Textarea
        placeholder={t('common.add_comment_placeholder')}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        onBlur={handleBlur}
        bg="white"
        resize="vertical"
      />
    </Box>
  );
};
